import { useSelector } from 'react-redux';

import ordersSelector from '../../../../../../../redux/selectors/orders-selectors';

export function useErrorText() {
  return useSelector(
    ordersSelector.selectOrderTotalsErrorMessageInOrderDetailDialog,
  );
}
